import React from 'react';
import { Alert, AlertDescription } from '@roger/ui-components';
import { AlertTriangle } from 'lucide-react';
import {
  MembersTable,
  EditAssignmentsDialog,
  useClinicianManager,
} from '../components/clinician-manager';

// ─── Component ──────────────────────────────────────────────────────────────

const ClinicianManager: React.FC = () => {
  const cm = useClinicianManager();

  // ── Permission gate ──

  if (!cm.hasAccess) {
    return (
      <div className='container mx-auto px-4 py-6'>
        <Alert className='border-red-200 bg-red-50'>
          <AlertDescription className='text-red-800 flex gap-2 items-center'>
            <AlertTriangle className='h-4 w-4 text-red-600' />
            You don&apos;t have permission to access the Clinician Manager.
            Please contact your administrator if you need access.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  // ── Render ──

  return (
    <div className='space-y-6'>
      {/* Members table */}
      <MembersTable
        members={cm.filteredMembers}
        isLoading={cm.isLoading}
        hasSearchQuery={!!cm.searchQuery}
        searchQuery={cm.searchQuery}
        onSearchChange={cm.setSearchQuery}
        onRefresh={cm.loadData}
        onEditMember={cm.openEditDialog}
      />

      {/* Edit dialog */}
      <EditAssignmentsDialog
        member={cm.editingMember}
        assignments={cm.assignments}
        isSaving={cm.isSaving}
        onClose={cm.closeEditDialog}
        onSave={cm.handleSave}
        onToggleAssigned={cm.toggleAssigned}
        onToggleFlag={cm.toggleFlag}
        onToggleFlagForAllAssigned={cm.toggleFlagForAllAssigned}
        onSelectAll={cm.selectAll}
        onDeselectAll={cm.deselectAll}
      />
    </div>
  );
};

export default ClinicianManager;
